import React from "react";
import { Grid, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import getTrans from "../../../../../languages/getTrans";

// Иконки криптовалют
const getCryptoIcon = (type) => {
  const icons = {
    bitcoin: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="20" fill="#F7931A"/>
        <path d="M28 17.5C28.3 15.4 26.8 14.3 24.6 13.5L25.3 10.6L23.5 10.2L22.8 13C22.3 12.9 21.8 12.8 21.3 12.7L22 9.8L20.2 9.4L19.5 12.3C19.1 12.2 18.7 12.1 18.4 12L16.2 11.4L15.7 13.3C15.7 13.3 17 13.6 17 13.6C17.7 13.8 17.8 14.2 17.8 14.6L16.3 20.8C16.2 21.1 16 21.4 15.5 21.3C15.5 21.3 14.3 21 14.3 21L13.4 23L15.5 23.5C15.9 23.6 16.4 23.7 16.8 23.8L16.1 26.8L17.9 27.2L18.6 24.3C19.1 24.4 19.6 24.5 20.1 24.6L19.4 27.5L21.2 27.9L21.9 24.9C24.7 25.4 26.8 25.2 27.7 22.7C28.4 20.8 27.7 19.7 26.3 19C27.4 18.7 28.2 18 28 17.5ZM24.5 21.5C24 23.5 20.3 22.3 19.1 22L19.9 18.5C21.1 18.8 25.1 19.4 24.5 21.5ZM25 17.5C24.6 19.3 21.6 18.3 20.6 18.1L21.3 14.9C22.3 15.1 25.4 15.6 25 17.5Z" fill="white"/>
      </svg>
    ),
    usdt_trc20: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="20" fill="#50AF95"/>
        <path d="M23 18V15H27V11H13V15H17V18C12 18.2 9 19.8 9 21.8C9 23.8 12 25.4 17 25.6V32H23V25.6C28 25.4 31 23.8 31 21.8C31 19.8 28 18.2 23 18ZM20 24C15 24 11 22.8 11 21.8C11 20.8 15 19.6 20 19.6C25 19.6 29 20.8 29 21.8C29 22.8 25 24 20 24Z" fill="white"/>
      </svg>
    ),
    eth: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="20" fill="#627EEA"/>
        <path d="M20 8L19.6 9.4V24.8L20 25.2L27 20.8L20 8Z" fill="white" fillOpacity="0.6"/>
        <path d="M20 8L13 20.8L20 25.2V8Z" fill="white"/>
        <path d="M20 26.8L19.7 27.2V32.4L20 33.2L27 22.4L20 26.8Z" fill="white" fillOpacity="0.6"/>
        <path d="M20 33.2V26.8L13 22.4L20 33.2Z" fill="white"/>
        <path d="M20 25.2L27 20.8L20 17V25.2Z" fill="white" fillOpacity="0.2"/>
        <path d="M13 20.8L20 25.2V17L13 20.8Z" fill="white" fillOpacity="0.6"/>
      </svg>
    ),
    bsc: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="20" fill="#F3BA2F"/>
        <path d="M15 20L12 17L15 14L18 17L15 20ZM20 15L23 12L26 15L23 18L20 15ZM20 25L23 22L26 25L23 28L20 25ZM25 20L22 17L25 14L28 17L25 20ZM20 20L17 17L20 14L23 17L20 20Z" fill="white"/>
      </svg>
    )
  };
  
  return icons[type] || icons.bitcoin;
};

const CryptoSelector = ({ cryptoList, selectedCrypto, onSelect }) => {
  const classes = useStyles();

  const defaultCryptoList = [
    { id: 'bitcoin', name: 'Bitcoin', type: 'bitcoin' },
    { id: 'usdt_trc20', name: 'USDT-TRC20', type: 'usdt_trc20' },
    { id: 'eth', name: 'ETH', type: 'eth' },
    { id: 'bsc', name: 'BSC', type: 'bsc' }
  ];

  const cryptos = cryptoList || defaultCryptoList;
  
  const getCryptoTranslatedName = (name) => {
    return getTrans(`cryptoSelector.${name}`) || name;
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1.5}>
        {cryptos.map((crypto) => (
          <Grid item xs={3} key={crypto.id}>
            <Button
              fullWidth
              className={clsx(classes.cryptoButton, {
                [classes.cryptoButtonActive]: selectedCrypto === crypto.id
              })}
              onClick={() => onSelect?.(crypto)}
            >
              <div className={classes.cryptoIcon}>
                {getCryptoIcon(crypto.type)}
              </div>
              <div className={classes.cryptoName}>{getCryptoTranslatedName(crypto.name)}</div>
            </Button>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 16,
    marginBottom: 16,
  },
  cryptoButton: {
    minHeight: 80,
    display: "flex!important",
    flexDirection: "column!important",
    alignItems: "center!important",
    justifyContent: "center!important",
    gap: "8px!important",
    background: "#2C3E50!important",
    border: "2px solid transparent!important",
    borderRadius: "12px!important",
    padding: "12px 8px!important",
    transition: "all 0.3s ease!important",

    "&:hover": {
      background: "#34495E!important",
    }
  },
  cryptoButtonActive: {
    borderColor: "#FB7800!important",
    background: "#2C3E50!important",
  },
  cryptoIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cryptoName: {
    fontSize: 12,
    fontWeight: 500,
    color: "white",
    textTransform: "none",
    textAlign: "center",
    lineHeight: "14px",
  },
}));

export default CryptoSelector;
